<section class="page-shell">
  <header class="page-hero dbw-card dbw-card--xl">
    <div>
      <p class="eyebrow">Minotaure</p>
      <h3>{{ pageTitle() }}</h3>
    </div>

    <div class="hero-actions">
      <oui-button
        type="outlined"
        color="secondary"
        iconSuffix="sync"
        (click)="reload()"
        [disabled]="loading()">
        Recharger
      </oui-button>
      @if (workspace()?.status?.rollbackInsteadOfCommit && virtualDeletedInvestorIds().length > 0) {
        <oui-button
          type="outlined"
          color="secondary"
          (click)="resetSimulation()">
          Réinitialiser la simulation
        </oui-button>
      }
    </div>
  </header>

  @if (loading()) {
    <dbw-state-card appearance="loading">
      <p>Chargement de la metadata en cours.</p>
    </dbw-state-card>
  }

  @if (error() && !loading()) {
    <dbw-state-card
      appearance="error"
      title="Chargement impossible"
      titleLevel="h5">
      <p>{{ error() }}</p>
    </dbw-state-card>
  }

  @if (workspace(); as vm) {
    <dbw-summary-grid [items]="summaryItems()"></dbw-summary-grid>

    <dbw-state-card
      appearance="info"
      title="Diagnostic global">
      <div class="diagnostic-summary">
        <p>{{ diagnosticSummaryMessage() }}</p>
        <div class="tag-cluster diagnostic-tags">
          @for (diagnostic of diagnostics(); track diagnostic.key) {
            <oui-tag
              type="status"
              size="big"
              [status]="diagnostic.status">
              {{ diagnostic.label }}
            </oui-tag>
          }
        </div>
      </div>
    </dbw-state-card>

    @if (vm.hasInvestorPersonMappingConflicts) {
      <dbw-state-card
        appearance="error"
        title="Correction bloquée">
        <p>
          {{
            vm.investorPersonMappingConflictMessage ||
              'Des investisseurs de cette metadata sont liés à plusieurs personnes physiques Atlas.'
          }}
        </p>
        <dbw-investor-person-mapping-conflicts-table
          [conflicts]="vm.investorPersonMappingConflicts"></dbw-investor-person-mapping-conflicts-table>
      </dbw-state-card>
    }

    @if (anomalyDiagnostics().length > 0) {
      <article class="panel dbw-card dbw-card--xl anomaly-panel">
        <div class="panel-heading">
          <div>
            <h5>Anomalies de la metadata</h5>
          </div>
          <oui-tag
            type="status"
            status="error">
            {{ anomalyDiagnostics().length }} type(s)
          </oui-tag>
        </div>

        <div class="diagnostic-list">
          @for (diagnostic of anomalyDiagnostics(); track diagnostic.kind) {
            <section class="diagnostic-block">
              <div class="subheading">
                <h6>{{ diagnostic.label }}</h6>
                <oui-tag
                  type="status"
                  status="error">
                  {{ diagnostic.rows.length }} ligne(s)
                </oui-tag>
              </div>

              <oui-table
                class="data-table"
                [lineSizing]="'dense'">
                <table
                  mat-table
                  [dataSource]="diagnostic.rows">
                  <ng-container matColumnDef="detection">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Détection
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <oui-tag
                        type="status"
                        status="error">
                        {{ row.detectionLabel || diagnostic.label }}
                      </oui-tag>
                      <div>AvancementId: {{ row.avancementId }}</div>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="investor">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Investisseur
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <dbw-investor-card
                        [id]="row.investorId"
                        [code]="row.investorCode || 'Code inconnu'"
                        [name]="row.displayName || 'Investisseur sans nom'"
                        [statusCode]="row.statusCode"></dbw-investor-card>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="consultant">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Consultant
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <dbw-consultant-card
                        [id]="row.consultantId"
                        [code]="row.consultantCode || '-'"
                        [name]="row.consultantName || '-'"
                        [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="status">
                    <th
                      mat-header-cell
                      *matHeaderCellDef>
                      Statut
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let row">
                      <dbw-investor-status-tag [statusCode]="row.statusCode"></dbw-investor-status-tag>
                    </td>
                  </ng-container>
                  <tr
                    mat-header-row
                    *matHeaderRowDef="anomalyColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: anomalyColumns"></tr>
                </table>
              </oui-table>
            </section>
          }
        </div>
      </article>
    }

    <section class="content-grid">
      <article class="panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <h5>Investisseurs de la metadata</h5>
        </div>
        <oui-table
          class="data-table"
          [lineSizing]="'dense'">
          <table
            mat-table
            [dataSource]="vm.rows">
            <ng-container matColumnDef="investor">
              <th
                mat-header-cell
                *matHeaderCellDef>
                Investisseur
              </th>
              <td
                mat-cell
                *matCellDef="let row">
                <dbw-investor-card
                  [id]="row.investorId"
                  [code]="row.investorCode || 'Code inconnu'"
                  [name]="row.displayName || 'Investisseur sans nom'"
                  [statusCode]="row.statusCode"></dbw-investor-card>
              </td>
            </ng-container>
            <ng-container matColumnDef="consultant">
              <th
                mat-header-cell
                *matHeaderCellDef>
                Consultant
              </th>
              <td
                mat-cell
                *matCellDef="let row">
                <dbw-consultant-card
                  [id]="row.consultantId"
                  [code]="row.consultantCode || '-'"
                  [name]="row.consultantName || '-'"
                  [statusCode]="row.consultantStatusCode"></dbw-consultant-card>
              </td>
            </ng-container>
            <ng-container matColumnDef="status">
              <th
                mat-header-cell
                *matHeaderCellDef>
                Statut
              </th>
              <td
                mat-cell
                *matCellDef="let row">
                <dbw-investor-status-tag [statusCode]="row.statusCode"></dbw-investor-status-tag>
              </td>
            </ng-container>
            <ng-container matColumnDef="arianeId">
              <th
                mat-header-cell
                *matHeaderCellDef>
                ArianeId
              </th>
              <td
                mat-cell
                *matCellDef="let row">
                {{ row.arianeId ?? '-' }}
              </td>
            </ng-container>
            <tr
              mat-header-row
              *matHeaderRowDef="rowColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: rowColumns"></tr>
          </table>
        </oui-table>
      </article>

      <article class="panel dbw-card dbw-card--xl recueil-check-panel">
        <div class="panel-heading">
          <div>
            <h5>Contrôles recueil inter-consultants</h5>
            <p>Éléments recueil partagés par les investisseurs visibles de cette metadata et rattachés à plusieurs consultants.</p>
          </div>
          <oui-tag
            type="status"
            [status]="getRecueilCheckStatus()">
            {{ getRecueilCheckLabel() }}
          </oui-tag>
        </div>

        @if (recueilChecksLoading()) {
          <dbw-state-card
            appearance="loading"
            [compact]="true">
            <p>Chargement des contrôles recueil en cours.</p>
          </dbw-state-card>
        } @else if (recueilChecksError()) {
          <dbw-state-card
            appearance="error"
            [compact]="true">
            <p>{{ recueilChecksError() }}</p>
          </dbw-state-card>
        } @else if (recueilCrossConsultantRows().length === 0) {
          <dbw-state-card
            appearance="info"
            [compact]="true">
            <p>Aucun élément recueil partagé entre plusieurs consultants pour les investisseurs visibles.</p>
          </dbw-state-card>
        } @else {
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="recueilCrossConsultantRows()">
              <ng-container matColumnDef="recueil">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Élément recueil
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="content-short">
                    <strong>{{ row.recueilKindLabel }} #{{ row.recueilObjectId }}</strong>
                    <div>{{ row.recueilObjectLabel }}</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="consultants">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Consultants
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="content-short">
                    <strong>{{ row.consultantCount }}</strong>
                    <div>{{ row.investorCount }} investisseur(s)</div>
                  </div>
                </td>
              </ng-container>

              <ng-container matColumnDef="investors">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseurs concernés
                </th>
                <td
                  mat-cell
                  *matCellDef="let row">
                  <div class="recueil-investor-list">
                    @for (investor of row.investors; track investor.investorId) {
                      <div class="recueil-investor-list__item">
                        <dbw-investor-card
                          [id]="investor.investorId"
                          [code]="investor.investorCode || 'Code inconnu'"
                          [name]="investor.displayName || 'Investisseur sans nom'"
                          [statusCode]="investor.statusCode"></dbw-investor-card>
                        <dbw-consultant-card
                          [id]="investor.consultantId"
                          [code]="investor.consultantCode || '-'"
                          [name]="investor.consultantName || '-'"
                          [statusCode]="investor.consultantStatusCode"></dbw-consultant-card>
                      </div>
                    }
                  </div>
                </td>
              </ng-container>

              <tr
                mat-header-row
                *matHeaderRowDef="recueilColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: recueilColumns"></tr>
            </table>
          </oui-table>
        }
      </article>

      <article class="workflow-separator dbw-card dbw-card--xl">
        <div>
          <h5>Correction des doublons de metadata</h5>
          <p>Workflow existant de sélection, prévisualisation et exécution d'une correction de doublon investisseur.</p>
        </div>
        <oui-tag
          type="status"
          [status]="vm.hasDuplicates ? 'to-correct' : 'completed'">
          {{ vm.hasDuplicates ? 'Doublons détectés' : 'Aucun doublon' }}
        </oui-tag>
      </article>

      @if (vm.hasDuplicates) {
        <article class="panel dbw-card dbw-card--xl">
          <div class="panel-heading">
            <h5>Suggestion de suppression</h5>
            <oui-tag
              type="status"
              status="to-correct">
              {{ vm.duplicateAnalysis.duplicateGroups.length }} groupe(s)
            </oui-tag>
          </div>
          @if (vm.duplicateAnalysis.firstDuplicateGroup; as firstGroup) {
            <section class="analysis-banner dbw-card dbw-card--md">
              <div>
                <strong>{{ firstGroup.matchLabel }} : {{ firstGroup.matchValue }}</strong>
                @if (firstGroup.requiresManualVerification) {
                  <p>Vérification manuelle requise : les scores sont proches.</p>
                }
              </div>
              @if (canExecuteMetadataCorrectionAction() && firstGroup.automaticSuggestion; as suggestion) {
                <oui-button
                  type="contained"
                  [disabled]="correctionBlocked() || previewLoading() || executing()"
                  (click)="selectCandidate(suggestion)">
                  Choisir la suggestion
                </oui-button>
              }
            </section>
          }
          <oui-table
            class="data-table"
            [lineSizing]="'dense'">
            <table
              mat-table
              [dataSource]="firstGroupCandidates()">
              <ng-container matColumnDef="rank">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Rang
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate; let index = index">
                  #{{ index + 1 }}
                </td>
              </ng-container>
              <ng-container matColumnDef="investor">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Investisseur
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  <div class="content-long">
                    <dbw-investor-card
                      [id]="candidate.investor.investorId"
                      [code]="candidate.investor.investorCode || 'Code inconnu'"
                      [name]="candidate.investor.displayName || 'Investisseur sans nom'"
                      [statusCode]="candidate.investor.statusCode"></dbw-investor-card>

                    @if (candidate.isAutomaticSuggestion) {
                      <div>Suggestion automatique</div>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Statut
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  <dbw-investor-status-tag [statusCode]="candidate.investor.statusCode"></dbw-investor-status-tag>
                </td>
              </ng-container>
              <ng-container matColumnDef="gedDocuments">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Documents GED
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  <div class="ged-document-cell">
                    <span>{{ formatGedDocumentCount(candidate.investor.gedDocumentCount) }}</span>
                    @if (hasGedDocumentNames(candidate.investor)) {
                      <oui-infos-bulle [bulleTitle]="getGedDocumentNamesTitle(candidate.investor)">
                        @for (documentName of candidate.investor.gedDocumentNames; track documentName + $index) {
                          <div class="ged-document-name">
                            {{ documentName }}
                          </div>
                        }
                      </oui-infos-bulle>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="boxOperations">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Opérations Box
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  <oui-tag
                    type="status"
                    size="big"
                    [status]="getBoxPlacementOperationsStatus(candidate.investor.hasBoxPlacementOperations)">
                    {{ getBoxPlacementOperationsLabel(candidate.investor.hasBoxPlacementOperations) }}
                  </oui-tag>
                </td>
              </ng-container>
              <ng-container matColumnDef="immoOptionIntention">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Intention option Immo
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  <oui-tag
                    type="status"
                    size="big"
                    [status]="getImmoOptionIntentionStatus(candidate.investor.hasImmoOptionIntention)">
                    {{ getImmoOptionIntentionLabel(candidate.investor.hasImmoOptionIntention) }}
                  </oui-tag>
                </td>
              </ng-container>
              <ng-container matColumnDef="score">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  <div class="score-header">
                    Score
                    <oui-infos-bulle bulleTitle="Calcul du score">
                      Le score est calculé par les règles métier de suggestion. Plus il est élevé, plus l'investisseur est un bon candidat à
                      la suppression. La suggestion automatique correspond au meilleur score et une vérification manuelle est demandée
                      lorsque les meilleurs scores sont trop proches.
                    </oui-infos-bulle>
                  </div>
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  <div class="score-cell">
                    {{ candidate.totalScore }}

                    <dbw-investor-deletion-score-details
                      class="score-cell__details"
                      [investorId]="candidate.investor.investorId"
                      [evaluations]="candidate.evaluations"></dbw-investor-deletion-score-details>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="actions">
                <th
                  mat-header-cell
                  *matHeaderCellDef>
                  Action
                </th>
                <td
                  mat-cell
                  *matCellDef="let candidate">
                  @if (canExecuteMetadataCorrectionAction()) {
                    <oui-button
                      type="text"
                      iconSuffix="play_arrow"
                      [disabled]="correctionBlocked() || previewLoading() || executing()"
                      (click)="selectCandidate(candidate)">
                      Choisir
                    </oui-button>
                  }
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="candidateColumns"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: candidateColumns"></tr>
            </table>
          </oui-table>
        </article>
      } @else {
        <article class="panel dbw-card dbw-card--xl">
          <h5>Aucun doublon restant</h5>
          <p>La metadata ne présente plus de groupe de doublons traitable.</p>
        </article>
      }
      <article class="panel dbw-card dbw-card--xl">
        <div class="panel-heading">
          <div>
            <h5>Préparation de la correction</h5>
          </div>
        </div>
        @if (previewLoading()) {
          <dbw-state-card
            appearance="loading"
            [compact]="true">
            <p>Analyse des relations de couple en cours.</p>
          </dbw-state-card>
        }
        @if (previewError()) {
          <dbw-state-card
            appearance="error"
            [compact]="true">
            <p>{{ previewError() }}</p>
          </dbw-state-card>
        }
        @if (correctionBlocked()) {
          <dbw-state-card
            appearance="error"
            [compact]="true">
            <p>La correction est désactivée tant que les associations Investisseur / PersonnePhysique Atlas ne sont pas rétablies.</p>
          </dbw-state-card>
        }
        @if (canExecuteMetadataCorrectionAction() && !previewLoading() && !preview() && !correctionBlocked()) {
          <section class="empty-state">
            <p>Choisissez un investisseur dans la liste ci-dessus pour préparer l'exécution.</p>
          </section>
        }
        @if (preview(); as previewVm) {
          <div class="preview-summary dbw-card dbw-card--md">
            <oui-tag
              type="status"
              [status]="previewVm.requiresRelationshipReplacement ? 'todo' : 'completed'">
              {{ previewVm.requiresRelationshipReplacement ? 'Remplacements requis' : 'Aucun remplacement requis' }}
            </oui-tag>
            <p>{{ previewVm.summaryMessage }}</p>
          </div>
          @if (previewVm.requiresRelationshipReplacement) {
            <div class="replacement-list">
              @for (option of previewVm.replacementOptions; track option.linkedInvestor.investorId) {
                <article class="replacement-card dbw-card dbw-card--md">
                  <dbw-investor-card
                    [id]="option.linkedInvestor.investorId"
                    [code]="option.linkedInvestor.investorCode || 'Code inconnu'"
                    [name]="option.linkedInvestor.displayName || 'Investisseur sans nom'"
                    [statusCode]="option.linkedInvestor.statusCode"></dbw-investor-card>
                  <oui-select
                    label="Investisseur de remplacement"
                    [value]="replacementSelections()[option.linkedInvestor.investorId] ?? null"
                    [options]="replacementOptionChoices()[option.linkedInvestor.investorId] ?? []"
                    (valueChange)="onReplacementSelected(option.linkedInvestor.investorId, $event)">
                  </oui-select>
                </article>
              }
            </div>
          }
          @if (canExecuteMetadataCorrectionAction()) {
            <div class="execution-actions">
              <oui-button
                iconSuffix="check_circle"
                (click)="executeCorrection()"
                [disabled]="!canExecute()">
                Exécuter la correction
              </oui-button>
            </div>
          }
        }
      </article>
      @if (execution(); as executionVm) {
        <article class="panel dbw-card dbw-card--xl">
          <div class="panel-heading">
            <div>
              <h5>Résultat de l'exécution</h5>
            </div>
            <oui-tag
              type="status"
              [status]="executionVm.success ? 'completed' : 'error'">
              {{ executionVm.success ? 'Succès' : 'Échec' }}
            </oui-tag>
          </div>
          <div class="step-grid">
            <article class="step-card dbw-card dbw-card--md">
              <oui-tag
                type="status"
                [status]="getStepStatus(executionVm.coupleRelationStep)">
                {{ executionVm.coupleRelationStep.stepName }}
              </oui-tag>
              <strong>{{ executionVm.coupleRelationStep.affectedRows }} relation(s)</strong>
              <p>{{ executionVm.coupleRelationStep.message }}</p>
            </article>
            <article class="step-card dbw-card dbw-card--md">
              <oui-tag
                type="status"
                [status]="getStepStatus(executionVm.atlasResetStep)">
                {{ executionVm.atlasResetStep.stepName }}
              </oui-tag>
              <strong>{{ executionVm.atlasResetStep.affectedRows }} ligne(s)</strong>
              <p>{{ executionVm.atlasResetStep.message }}</p>
            </article>
            <article class="step-card dbw-card dbw-card--md">
              <oui-tag
                type="status"
                [status]="getStepStatus(executionVm.minotaureDeletionStep)">
                {{ executionVm.minotaureDeletionStep.stepName }}
              </oui-tag>
              <strong>{{ executionVm.minotaureDeletionStep.affectedRows }} ligne(s)</strong>
              <p>{{ executionVm.minotaureDeletionStep.message }}</p>
            </article>
          </div>
        </article>
      }
    </section>
  }
</section>
